import {
  INVENTORY_ITEM_DETAIL,
  INVENTORY_ITEM_LIST,
  LOW_STOCK_LIST,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// /low-stock doesn't share a URL prefix with /inventory-item, so it can't nest under
// the same parent (react-router v6 throws "Absolute route path ... nested under path
// ... is not valid" when a child's absolute path isn't an extension of its parent's) —
// kept as its own flat top-level entry instead.
export const InventoryRoutes: IAppRoutes = {
  link: INVENTORY_ITEM_LIST,
  childrens: [
    {
      link: INVENTORY_ITEM_LIST,
      element: guard(() => import('@modules/inventory/InventoryItem'), [INVENTORY_ITEM_LIST]),
    },
    {
      link: INVENTORY_ITEM_DETAIL({id: ':id'}),
      element: guard(() => import('@modules/inventory/InventoryItem/Detail'), [INVENTORY_ITEM_LIST]),
    },
  ],
}

export const LowStockRoutes: IAppRoutes = {
  link: LOW_STOCK_LIST,
  element: guard(() => import('@modules/inventory/LowStock'), [LOW_STOCK_LIST]),
}
